import { IconButton } from "@itk/mui-components";
import { useSnackbar } from "notistack";
import { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "src/store";
import { isApiError, isItkException } from "src/utils/error-utils";
import { toastActions, ItkToastr } from "./itk-toastr-store";
import { DekoxIcon } from "../deko-x-icons";
import { useItkException } from "../error-viewer/use-itk-exception";

const mapStateToProps = (state: RootState) => ({ ...state.generalReducer.itkToastrReducer });

type Props = ReturnType<typeof mapStateToProps> & typeof toastActions;

const ITKToastrBase = (props: Props) => {
  const { alerts, removeAlert } = props;
  const { getItkExceptionMessage } = useItkException();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const mapErrorToMessage = useCallback(
    (alert: ItkToastr) => {
      if (typeof alert.message === "string") return alert.message;
      else if (isApiError(alert.message) && isItkException(alert.message.body)) return getItkExceptionMessage(alert.message.body);
      else if (isItkException(alert.message)) return getItkExceptionMessage(alert.message);

      // eslint-disable-next-line @itk/undesired-code-alerter
      console.log({ error: alert.message }); // This console.log is allowed
      return "Unexpected error occured";
    },
    [getItkExceptionMessage]
  );

  useEffect(() => {
    for (const alert of alerts) {
      enqueueSnackbar(mapErrorToMessage(alert), {
        key: alert.id,
        variant: alert.variant,
        preventDuplicate: true,
        autoHideDuration: alert.autoHideDuration,
        onClose: () => removeAlert(alert.id),
        action: (
          <IconButton k={alert.id} onClick={() => closeSnackbar(alert.id)} color="inherit">
            <DekoxIcon icon="close" />
          </IconButton>
        )
      });
    }
  }, [alerts, enqueueSnackbar, closeSnackbar]);

  return null;
};

export const ITKToastr = connect(mapStateToProps, toastActions)(ITKToastrBase);
